import { render } from "./LoginCombinedPanel.vue?vue&type=template&id=dbb55c12&lang=pug"
import script from "./LoginCombinedPanel.vue?vue&type=script&lang=js"
export * from "./LoginCombinedPanel.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__